/**
 * @Author: Zewei
 * @Date:   2018-01-22T19:01:00+08:00
 * @Last modified by:
 * @Last modified time: 2018-01-24T11:19:08+08:00
 */
 import { SystemSettingConstants } from '../constants/system-setting-constants.js';

 const initState = {
     actionStatus: false
 };

 export default function systemSetting (state = initState, action) {
     switch (action.type) {
         // 角色管理
         case SystemSettingConstants.ActionTypes.FETCHDATA:
             return {...state, ...action.payload};
         case SystemSettingConstants.ActionTypes.FETCHSUCCESS:
             return {...state, ...action.payload};
         case SystemSettingConstants.ActionTypes.FETCHFAILURE:
             return {...state, ...action.payload};
         case SystemSettingConstants.ActionTypes.CREATEROLESUCCESS:
             return {...state, ...action.payload};
         case SystemSettingConstants.ActionTypes.CREATEROLEFAILURE:
             return {...state, ...action.payload};
         case SystemSettingConstants.ActionTypes.DELETEROLESSUCCESS:
             return {...state, ...action.payload};
         case SystemSettingConstants.ActionTypes.DELETEROLEFAILURE:
             return {...state, ...action.payload};
         case SystemSettingConstants.ActionTypes.HIDDENMODAL:
             return {...state, ...action.payload};
         // 用户管理
         // case SystemSettingConstants.ActionTypes.HIDDENMODAL:
         //     return {...state, ...action.payload};
         // logger管理
         case SystemSettingConstants.ActionTypes.INITSYSTEMLOGGER:
         case SystemSettingConstants.ActionTypes.FETCHSYSTEMLOGGERSUCCESS:
         case SystemSettingConstants.ActionTypes.FETCHSYSTEMLOGGERFAILURE:
         case SystemSettingConstants.ActionTypes.INITSYSTEMLOGGERSETTING:
         case SystemSettingConstants.ActionTypes.FETCHSYSTEMLOGGERSETTINGSUCCESS:
         case SystemSettingConstants.ActionTypes.FETCHSYSTEMLOGGERSETTINGFAILURE:
            return {...state, ...action.payload};
         case SystemSettingConstants.ActionTypes.ADDSYSTEMLOGGERSETTINGSUCCESS:
         case SystemSettingConstants.ActionTypes.ADDSYSTEMLOGGERSETTINGFAILURE:
         case SystemSettingConstants.ActionTypes.SAVESYSTEMLOGGERSETTINGSUCCESS:
         case SystemSettingConstants.ActionTypes.SAVESYSTEMLOGGERSETTINGFAILURE:
            return {...state, ...action.payload};
        case SystemSettingConstants.ActionTypes.FETCHSYSTEMMODULESUCCESS:
        case SystemSettingConstants.ActionTypes.FETCHSYSTEMMODULEFAILURE:
            return {...state, ...action.payload};
        case SystemSettingConstants.ActionTypes.DELETEUSERSFAILURE:
            return {...state, ...action.payload};
        case SystemSettingConstants.ActionTypes.HANDLEAUTHORIZESUCCESS:
            return {...state, ...action.payload};
        case SystemSettingConstants.ActionTypes.DELETEUSERSSUCCESS:
            return {...state, ...action.payload};
        case SystemSettingConstants.ActionTypes.INACTIVEUSERSUCCESS:
            return {...state, ...action.payload};
        case SystemSettingConstants.ActionTypes.INACTIVEUSERFAILURE:
            return {...state, ...action.payload};
        case SystemSettingConstants.ActionTypes.UPDATEUSERSUCCESS:
            return {...state, ...action.payload};
        case SystemSettingConstants.ActionTypes.UPDATEUSERFAILURE:
            return {...state, ...action.payload};        
         default:
             return {...state};
     }
 }



// WEBPACK FOOTER //
// ./src/reducers/system-setting-reducer.js